import * as cooperativeVariantMapper from './cooperative-variant.mapper'
import ImportService from './import.service'
import { mapImportReportContent } from './import-reports/import-report.mapper'

export default class CooperativeVariantService {
  // `productSdk` (sans timeout) pour l'import d'un CSV volumineux, `productSdkWithTimeout`
  // pour les appels courts, qui étaient plafonnés à 20 s avant le passage au SDK.
  constructor({ productSdk, productSdkWithTimeout }) {
    this.productSdk = productSdk
    this.productSdkWithTimeout = productSdkWithTimeout
  }

  async import(cooperativeId, file) {
    const importReport = await this.productSdk.putDistributorCatalog({ cooperativeId }, file)
    return mapImportReportContent(importReport)
  }

  async downloadVariants(cooperativeId, cooperativeName) {
    // L'endpoint ne sert que du CSV : le SDK renvoie directement le contenu du fichier.
    const csv = await this.productSdkWithTimeout.getAllDistributeurVariantsCsv({ cooperativeId })

    const url = window.URL.createObjectURL(new Blob([csv]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', ImportService.createFileName(cooperativeName, 'variants'))
    document.body.appendChild(link)
    link.click()
  }

  async update(cooperativeVariant = {}) {
    const updatedVariant = await this.productSdkWithTimeout.updateDistributorVariant(
      { cooperativeVariantId: cooperativeVariant.id },
      cooperativeVariantMapper.mapToApi(cooperativeVariant),
    )
    // Le SDK avale le 422 et renvoie null : on rejette, comme le faisait axios avant.
    if (!updatedVariant) {
      throw new Error(`Variant distributeur ${cooperativeVariant.id} refusé par l'API product`)
    }
    return cooperativeVariantMapper.mapFromApi(updatedVariant)
  }
}
